let countries = require("i18n-iso-countries");
const {toggleSpinner} = require("../global/utilities");
let formSubmitted = false; // Add flag to prevent double submission

// Keep the country selection logic in DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".signup form") !== null) {
        let input = document.getElementById("mobile"),
            countrySelect = document.getElementById("address_country");

        if (input) {
            window.intlTelInput(input, {
                initialCountry: "fr",
                loadUtils: () => import("intl-tel-input/utils"),
            });
        } else {
            console.error("Element with id 'mobile' not found.");
        }

        countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

        const countryList = countries.getNames("fr");
        Object.entries(countryList).forEach(([code, name]) => {
            let option = document.createElement("option");
            option.value = code;
            option.textContent = name;

            if (code === "FR") {
                option.selected = true;
            }

            countrySelect.appendChild(option);
        });
    }
});

// Single form submission handler using jQuery
(($) => {
    const $form = $('.signup form');

    if(!$form.length) {
        return;
    }

    $form.off('submit').on('submit', function(e) {
        e.preventDefault();

        // Clear all previous error messages
        $form.find('.error-message').text('');

        // Validate form
        if (!validateForm($form)) {
            return false;
        }

        // Disable the button
        const submitButton = $('button[type="submit"]', $form);
        toggleSpinner(submitButton[0], true);

        // submitButton.find('.fa-spinner').css('display', 'inline-block');
        // submitButton.prop('disabled', true);

        if (formSubmitted) {
            console.log('Form already submitted');
            return false;
        }

        formSubmitted = true;

        const first_name        = $('#first_name').val();
        const last_name         = $('#last_name').val();
        const email             = $('#email').val();
        const gender            = $('input[name="gender"]:checked').val();
        const mobile            = $('#mobile').val();
        const birthDate         = $('#birth_date').val();
        const address           = $('#address').val();
        const addressCountry    = $('#address_country option:selected').text();
        const addressCountryIso = $('#address_country').val();
        const addressLocality   = $('#address_locality').val();
        const postalCode        = $('#postal_code').val();

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'user_signup',
                givenName: first_name,
                familyName: last_name,
                email: email,
                mobile: mobile,
                gender: gender,
                birthDate: birthDate,
                address: {
                    addressLocality: addressLocality,
                    postalCode: postalCode,
                    streetAddress: address,
                    addressCountry: addressCountry,
                    addressCountryIso: addressCountryIso
                }
            },
            success: function (response) {
                console.log(response.data);

                if (response.success) {
                    // setAuthCookie({
                    //     access_token: response.data.access_token,
                    //     token_type: "Bearer",
                    //     scope: response.data.scope,
                    //     refresh_token: response.data.refresh_token,
                    //     expires_in: response.data.expires_in
                    // });
                    $form.addClass('hidden');
                    $('.signup .signup-success-message').addClass('active');
                    // window.location.reload()
                } else {
                    toggleSpinner(submitButton[0], false);
                    // submitButton.find('.fa-spinner').css('display', 'none');
                    // submitButton.prop('disabled', false);

                    formSubmitted = false; // Reset flag after request completes

                    checkViolations(response.data);
                    // error_element.show()
                    // error_element.find('p span').html("Une erreur s'est produite");
                }
            },
            error: function (xhr, status, error) {
                toggleSpinner(submitButton[0], false);

                // submitButton.find('.fa-spinner').css('display', 'none');
                // submitButton.prop('disabled', false);

                console.log({
                    xhr,
                    status,
                    error,
                    response: xhr.responseText,
                    statusCode: xhr.status,
                    statusText: xhr.statusText
                });
                alert('Une erreur est survenue. Consultez la console pour plus de détails.');
            },
            complete: function() {
                formSubmitted = false; // Reset flag after request completes
            }
        });
    });
})(jQuery);

function validateForm($form) {
    const errors = [];

    // Required fields validation
    const requiredFields = {
        first_name: 'Le prénom est requis',
        last_name: 'Le nom est requis',
        email: 'L\'email est requis',
        mobile: 'Le téléphone est requis',
        birth_date: 'La date de naissance est requise',
        address: 'L\'adresse est requise',
        postal_code: 'Le code postal est requis',
        address_locality: 'La ville est requise'
    };

    Object.entries(requiredFields).forEach(([field, message]) => {
        const value = $form.find(`#${field}`).val().trim();
        if (!value) {
            errors.push(message);
            $form.find(`span[name="${field}"]`).text(message);
        } else {
            $form.find(`span[name="${field}"]`).text('');
        }
    });

    // Gender validation
    if (!$form.find('input[name="gender"]:checked').val()) {
        errors.push('La civilité est requise');
        $form.find('span[name="gender"]').text('La civilité est requise');
    } else {
        $form.find('span[name="gender"]').text('');
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const email = $form.find('#email').val().trim();
    if (email && !emailRegex.test(email)) {
        errors.push('Format d\'email invalide');
        $form.find('span[name="email"]').text('Format d\'email invalide');
    }

    // Date validation
    const birthDate = $form.find('#birth_date').val();
    if (birthDate) {
        const date = new Date(birthDate);
        const today = new Date();
        if (date > today) {
            errors.push('La date de naissance ne peut pas être dans le futur');
            $form.find('span[name="birth_date"]').text('La date de naissance ne peut pas être dans le futur');
        }
    }

    return errors.length === 0;
}

function toSnakeCase(str) {
    return str
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase()
        .replace(/^_/, '');
}

function checkViolations(response) {

    let errors = {
        'api.error.generic.less-than': 'Vous devez être agé(e) d\'au moins 16 ans.',
        'api.error.generic.invalid-phone-number': 'Le numéro de téléphone est invalide.',
        'api.error.generic.not-blank': 'Ce champ ne peut pas être vide.',
    }

    if (response.data.body.violations && response.data.body.violations.length > 0) {
        response.data.body.violations.forEach(violation => {
            const fieldName = toSnakeCase(violation.propertyPath);
            const errorSpan = jQuery(`span[name="${fieldName}"]`);
            if (errorSpan.length) {
                // Extract base error code without parameters
                const baseErrorCode = violation.message.split('?')[0];
                // Use mapped error message if available, otherwise use original message
                const errorMessage = errors[baseErrorCode] || violation.message;
                errorSpan.text(errorMessage);
            }
        });
    }
}
